import {connect} from "redux-vue";
import classNames from "classnames";
import * as appActions from "../actions/app";

const SimulationLink = {
  props: [
    'to',
    'app',
    'text',
    'goTo',
    'children',
    'activeClassName'
  ],

  methods: {
    /**
     *
     */
    handleClick() {
      this.goTo(this.to);
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const className = classNames(
      "cursor-pointer select-none",
      {[this.activeClassName]: this.to === this.app.slide}
    );

    return (
      <div onClick={this.handleClick} class={className}>
        { this.text || this.children }
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    app: state.simulation.app,
  };
}

function mapActionToProps(dispatch) {
  return {
    goTo: slide => dispatch(appActions.goTo(slide)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(SimulationLink);
